import { analytics } from '@lib/analytics/page-events';
import { claimGestureEntry } from '@lib/coveo/historyGesture';
import { RESULT_SECTION_SELECTOR } from './ownershipFilter.constants';

/**
 * Clears the URL-based ownership filter (`hideOwnership` param)
 * and removes the DOM attribute that hides owned assets.
 *
 * The write claims the gesture's history entry, so a clear that also
 * deselects Coveo facets (the mobile drawer's Clear all) has the search
 * parameter manager refine this entry instead of pushing a second one — one
 * gesture, one entry, and Back returns to the state before the clear rather
 * than to an intermediate the user never saw.
 */
export function clearOwnershipFilter(): void {
  if (typeof window === 'undefined') return;
  const currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.get('hideOwnership')) {
    currentUrl.searchParams.delete('hideOwnership');
    window.history.pushState({}, '', currentUrl);
    claimGestureEntry();
    document
      .querySelector(RESULT_SECTION_SELECTOR)
      ?.removeAttribute('data-hide-owned');
  }
}

/**
 * Clears the ownership filter as a user gesture: the toggle pushes a
 * filter_action for the same intent, so every surface that removes the filter
 * (breadcrumb chip, breadcrumbs Clear, drawer Clear) must track it identically.
 * Guarded on the live param so the event fires once, for the gesture that
 * actually clears something.
 */
export function deselectOwnershipFilter(): void {
  if (typeof window === 'undefined') return;
  if (!new URL(window.location.href).searchParams.get('hideOwnership')) return;
  analytics.pushFilterEvent({
    filter_action: 'deselect',
    filter_action_category: 'ownership',
    filter_action_label: 'hide_owned_assets',
  });
  clearOwnershipFilter();
}
